import { FormLabel } from "@material-ui/core";
import { BEST_DIPLOMA, CONTRACTUAL_MODE, DEPARTMENTS, DEROGATION_TYPE, EMPLOYER_TYPE, LAST_DIPLOMA_YEAR, LAST_DISPLOMA, NATIONALITY, OPCO_CONTRACT_TYPE, OPCOS, PRIVATEORPUBLIC, SEXES, SITUATION_BEFORE_CONTRACT, SOCIAL_REGIME, SPECIFIC_EMPLOYER, YESNO } from "./constants";
import { FormikAddressPicker, FormikAddressPickerNested, FormikAutocompleteInput, FormikDateInput, FormikPhoneField, FormikTextInput } from "@webapps/reactjs-tech-components";
import { ExpandMoreRounded } from "@material-ui/icons";
import { getCommunes } from "@webapps/business";
import DynamicContractLengths from "components/FormMapper/custom/DynamicContractLengths";

const ErrorMessage = ({ touched, error, message }) => {
  if (!touched || !error) return null;
  return (
    <span
      style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        color: '#F50057',
        fontSize: '10px',
        fontFamily: 'Roboto',
        marginTop: '4px',
      }}
    >
      {message || error}
    </span>
  );
};

export const componentMap = {
  text: ({ name, label, placeholder, formik, error, touched, settings, validation, required, customHandler, value, disabled }) => {
    const fieldValue = value ? value(formik.values) : formik.values?.[name] || '';
    return (
      <div style={{ position: 'relative' }}>
        <FormLabel>
          {label}
          {required && <span style={{ color: '#0060F9', fontSize: '10px', paddingLeft: '2px', verticalAlign: 'top' }}>*</span>}
        </FormLabel>
        <FormikTextInput
          fullWidth
          formik={formik}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          validation={validation}
          value={fieldValue} // Use the value function result
          onChange={(e) => {
            if (customHandler?.onChange) {
              customHandler.onChange(e, formik, e.target.value);
            } else {
              formik.setFieldValue(name, e.target.value);
            }
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
            if (customHandler?.onBlur) {
              customHandler.onBlur(e, formik, e.target.value);
            }
            if (settings.submitType === 'onBlur') {
              formik.submitForm();
            }
          }}
          showError={false}
        />
        <ErrorMessage touched={touched} error={error} message={validation?.message} />
      </div>
    );
  },
  number: ({ name, label, placeholder, formik, error, touched, settings, validation, required, value, disabled }) => {
    const fieldValue = value ? value(formik.values) : formik.values?.[name] || '';
    return (
      <div style={{ position: 'relative' }}>
        <FormLabel>
          {label}
          {required && <span style={{ color: '#0060F9', fontSize: '10px', paddingLeft: '2px', verticalAlign: 'top' }}>*</span>}
        </FormLabel>
        <FormikTextInput
          fullWidth
          formik={formik}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          validation={validation}
          value={fieldValue}
          onChange={(e) => {
            formik.setFieldValue(name, e.target.value);
          }}
          inputProps={{
            min: validation?.min ?? -9999999999,
            max: validation?.max ?? 9999999999,
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
            if (settings.submitType === 'onBlur') {
              formik.submitForm();
            }
          }}
          showError={false}
          type="number"
        />
        <ErrorMessage touched={touched} error={error} message={validation?.message} />
      </div>
    );
  },
  select: ({ name, label, placeholder, options, getOptionLabel, getValue, formik, error, touched, endAdornment, settings, validation, required, disableClearable, customHandler, value, disabled }) => {
    const fieldValue = value ? value(formik.values) : getValue(formik.values?.[name]) || null;
    return (
      <div style={{ position: 'relative' }}>
        <FormLabel>
          {label}
          {required && <span style={{ color: '#0060F9', fontSize: '10px', paddingLeft: '2px', verticalAlign: 'top' }}>*</span>}
        </FormLabel>
        <FormikAutocompleteInput
          formik={formik}
          fullWidth
          getOptionLabel={getOptionLabel}
          onChange={customHandler?.onChange || ((event, value) => {
            formik.setFieldValue(name, value?.value);
          })}
          onBlur={(e) => {
            formik.handleBlur(e);
            if (settings.submitType === 'onBlur') {
              formik.submitForm();
            }
          }}
          placeholder={placeholder}
          disableClearable={disableClearable}
          name={name}
          disabled={disabled}
          options={options}
          value={fieldValue}
          endAdornment={endAdornment || null}
          showError={false}
          customHandler={customHandler}
        />
        <ErrorMessage touched={touched} error={error} message={validation?.message} />
      </div>
    );
  },
  address: ({ name, label, placeholder, formik, error, touched, endAdornment, settings, validation, required, value, disabled }) => {
    const fieldValue = value ? value(formik.values) : formik.values?.[name] || '';
    return (
      <div style={{ position: 'relative' }}>
        <FormLabel>
          {label}
          {required && <span style={{ color: '#0060F9', fontSize: '10px', paddingLeft: '2px', verticalAlign: 'top' }}>*</span>}
        </FormLabel>
        <FormikAddressPicker
          formik={formik}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          fullWidth
          value={fieldValue}
          onChange={(e) => {
            formik.handleChange(e);
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
            if (settings.submitType === 'onBlur') {
              formik.submitForm();
            }
          }}
          endAdornment={endAdornment || null}
          showError={false}
        />
        <ErrorMessage touched={touched} error={error} message={validation?.message} />
      </div>
    );
  },
  addressNested: ({ name, label, placeholder, formik, error, touched, endAdornment, settings, validation, required, value, disabled }) => {
    const fieldValue = value ? value(formik.values) : formik.values?.[name]?.label || '';
    return (
      <div style={{ position: 'relative' }}>
        <FormLabel>
          {label}
          {required && <span style={{ color: '#0060F9', fontSize: '10px', paddingLeft: '2px', verticalAlign: 'top' }}>*</span>}
        </FormLabel>
        <FormikAddressPickerNested
          formik={formik}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          fullWidth
          value={fieldValue}
          onChange={(e) => {
            formik.handleChange(e);
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
            if (settings.submitType === 'onBlur') {
              formik.submitForm();
            }
          }}
          endAdornment={endAdornment || null}
          showError={false}
        />
        <ErrorMessage touched={touched} error={error} message={validation?.message} />
      </div>
    );
  },
  phone: ({ name, label, placeholder, formik, error, touched, settings, validation, required, value, disabled }) => {
    const fieldValue = value ? value(formik.values) : formik.values?.[name] || '';
    return (
      <div style={{ position: 'relative' }}>
        <FormLabel>
          {label}
          {required && <span style={{ color: '#0060F9', fontSize: '10px', paddingLeft: '2px', verticalAlign: 'top' }}>*</span>}
        </FormLabel>
        <FormikPhoneField
          formik={formik}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          fullWidth
          value={fieldValue}
          onBlur={(e) => {
            formik.handleBlur(e);
            if (settings.submitType === 'onBlur') {
              formik.submitForm();
            }
          }}
          showError={false}
        />
        <ErrorMessage touched={touched} error={error} message={validation?.message} />
      </div>
    );
  },
  date: ({ name, label, placeholder, formik, error, touched, settings, validation, required, value, disabled }) => {
    const fieldValue = value ? value(formik.values) : formik.values?.[name] || '';
    return (
      <div style={{ position: 'relative' }}>
        <FormLabel>
          {label}
          {required && <span style={{ color: '#0060F9', fontSize: '10px', paddingLeft: '2px', verticalAlign: 'top' }}>*</span>}
        </FormLabel>
        <FormikDateInput
          formik={formik}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          fullWidth
          value={fieldValue}
          onChange={(e) => {
            formik.setFieldValue(name, e);
            if (settings.submitType === 'onBlur') {
              formik.submitForm();
            }
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
          }}
          showError={false}
        />
        <ErrorMessage touched={touched} error={error} message={validation?.message} />
      </div>
    );
  },
  custom: ({ render, formik, error, touched, settings }) => {
    if (!render) return null;
    const CustomComponent = render(formik);
    return (
      <div style={{ position: 'relative' }}>
        {CustomComponent}
        {/* Optional: Add error handling if needed for custom components */}
        {touched && error && <ErrorMessage touched={touched} error={error} message={error} />}
      </div>
    );
  },
  none: () => null,
};

export const employerFormConfig = [
  {
    name: "siret",
    label: "SIRET",
    type: "text",
    required: true,
    placeholder: "923 384 883 48324",
    getInitial: (info) => {
      const siret = info?.businessEmployer?.business?.siret || null;
      return siret ? String(siret).replace(/\s/g, '') : null;
    },
    validation: {
      requiredLength: 14,
      numeric: true,
      format: [3, 3, 3, 5],
      message: "Le SIRET doit être composé de 14 chiffres.",
    },
  },
  {
    name: "totalEmployees",
    label: "Effectif",
    type: "number",
    required: true,
    placeholder: "1294",
    getInitial: (info) => info?.businessEmployer?.totalEmployees || 0,
    validation: {
      min: 0,
      max: 99999999,
      message: "Choisissez un nombre entre 0 et 99 999 999.",
    }
  },
  {
    name: "lastname",
    label: "Nom du contact",
    type: "text",
    required: true,
    placeholder: "Bichi",
    getInitial: (info) => info?.businessEmployer?.lastname || null,
  },
  {
    name: "firstname",
    label: "Prénom du contact",
    type: "text",
    required: true,
    placeholder: "Arnaud",
    getInitial: (info) => info?.businessEmployer?.firstname || null,
  },
  {
    name: "email",
    label: "Email du contact",
    type: "text",
    required: true,
    placeholder: "support@linkpick.fr",
    getInitial: (info) => info?.businessEmployer?.email || null,
    validation: {
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "L'email doit être valide.",
    },
  },
  {
    name: "type",
    label: "Type d'employeur",
    type: "select",
    required: true,
    options: EMPLOYER_TYPE,
    disableClearable: true,
    placeholder: "Association",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? EMPLOYER_TYPE.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.businessEmployer?.type || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "specialization",
    label: "Employeur spécifique",
    type: "select",
    required: true,
    options: SPECIFIC_EMPLOYER,
    disableClearable: true,
    placeholder: "Aucun des cas",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? SPECIFIC_EMPLOYER.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.businessEmployer?.specialization || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "address",
    label: "Adresse",
    type: "address",
    required: true,
    placeholder: "61 Bd des Dames, 13002 Marseille",
    getInitial: (info) => info?.businessEmployer?.address || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "city",
    type: "none",
    required: false,
    getInitial: (info) => info?.businessEmployer?.city || null,
  },
  {
    name: "cityCode",
    type: "none",
    required: false,
    getInitial: (info) => info?.businessEmployer?.cityCode || null,
  },
  {
    name: "addressDetails",
    label: "Complément d'adresse",
    type: "text",
    required: false,
    placeholder: "Rez-de-chaussée, porte 2...",
    getInitial: (info) => info?.businessEmployer?.addressDetails || null,
  },
  {
    name: "number",
    label: "N° de rue",
    type: "text",
    required: true,
    placeholder: "61",
    getInitial: (info) => info?.businessEmployer?.number || null,
  },
  {
    name: "street",
    label: "Voie",
    type: "text",
    required: true,
    placeholder: "Bd des Dames",
    getInitial: (info) => info?.businessEmployer?.street || null,
  },
  {
    name: "phone",
    label: "Téléphone",
    type: "phone",
    required: true,
    placeholder: "06 12 34 56 78",
    getInitial: (info) => info?.businessEmployer?.phone || null,
    validation: {
      message: "Le numéro de téléphone doit être valide et français.",
      regex: /^(0|\+33)[1-9](\s?\d{2}){4}$/,
    },
  },
  {
    name: "codeNAF",
    label: "Code NAF",
    type: "text",
    required: true,
    placeholder: "4631Z",
    getInitial: (info) => info?.businessEmployer?.codeNAF || null,
    validation: {
      regex: /^[0-9]{4}[A-Z]$/,
      requiredLength: 5,
      message: "Le code NAF doit être valide.",
    },
  },
  {
    name: "codeIDCC",
    label: "Code IDCC",
    type: "text",
    required: true,
    placeholder: "1486",
    getInitial: (info) => info?.businessEmployer?.codeIDCC || null,
    validation: {
      regex: /^[0-9]{4}$/,
      requiredLength: 4,
      numeric: true,
      message: "Le code IDCC doit être valide.",
    },
  },
  {
    name: "collectiveConvention",
    label: "Convention collective",
    type: "text",
    placeholder: "Restauration de collectivités",
    required: true,
    getInitial: (info) => info?.businessEmployer?.collectiveConvention || null,
  },
  {
    name: "organization",
    label: "Employeur publique",
    type: "select",
    required: true,
    options: YESNO,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.businessEmployer?.business?.organization?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "unemploymentInsurance",
    label: "Assurance chômage",
    type: "select",
    required: true,
    options: YESNO,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.businessEmployer?.unemploymentInsurance?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "pensionFund",
    label: "Caisse de retraite",
    type: "text",
    required: true,
    placeholder: "CEG",
    getInitial: (info) => info?.businessEmployer?.pensionFund || null,
  },
  {
    name: "opco",
    label: "Opérateur de compétences (OPCO)",
    type: "select",
    required: true,
    options: OPCOS,
    disableClearable: true,
    placeholder: "Afdas",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? OPCOS.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.businessEmployer?.opco || null,
    endAdornment: <ExpandMoreRounded />,
  },
];

export const studentFormConfig = [
  {
    name: "firstname",
    label: "Prénom",
    type: "text",
    required: true,
    placeholder: "Jean",
    getInitial: (info) => info?.individual?.firstname || null,
  },
  {
    name: "lastname",
    label: "Nom",
    type: "text",
    required: true,
    placeholder: "Dupont",
    getInitial: (info) => info?.individual?.lastname || null,
  },
  {
    name: "nameBirth",
    label: "Nom de naissance",
    type: "text",
    required: true,
    placeholder: "Dupont",
    getInitial: (info) => info?.individual?.individualContract?.nameBirth || null,
  },
  {
    name: "socialSecurityNumber",
    label: "Numéro de sécurité sociale",
    type: "text",
    required: true,
    placeholder: "1 41 06 80 782 00 57",
    getInitial: (info) => {
      const ssn = info?.individual?.individualContract?.socialSecurityNumber || '';
      const key = info?.individual?.individualContract?.socialSecurityNumberKey || '';
      return ssn && key ? `${ssn}${key}` : null;
    },
    validation: {
      requiredLength: 15,
      format: [1, 2, 2, 2, 3, 3, 2],
      numeric: true,
      message: "Le numéro de sécurité sociale doit contenir 15 chiffres.",
    },
    customHandler: {
      onChange: (e, formik, value) => {
        const cleanValue = value.replace(/\s/g, '').slice(0, 15);
        formik.setFieldValue('socialSecurityNumber', cleanValue);
        if (cleanValue.length === 15) {
          formik.setFieldValue('socialSecurityNumberKey', cleanValue.slice(13, 15));
        }
      },
      onBlur: (e, formik, value) => {
        const cleanValue = value.replace(/\s/g, '').slice(0, 15);
        formik.setFieldValue('socialSecurityNumber', cleanValue.slice(0, 13));
        formik.setFieldValue('socialSecurityNumberKey', cleanValue.slice(13, 15));

        formik.submitForm().then(() => {
          formik.setFieldValue('socialSecurityNumber', cleanValue);
        })
      },
    },
  },
  {
    name: "socialSecurityNumberKey",
    type: "none",
    required: true,
    getInitial: (info) => info?.individual?.individualContract?.socialSecurityNumberKey || null,
  },
  {
    name: "birthDate",
    label: "Date de naissance",
    type: "date",
    required: true,
    placeholder: "JJ/MM/AAAA",
    getInitial: (info) => info?.individual?.birthDate || null,
  },
  {
    name: "sex",
    label: "Sexe",
    type: "select",
    required: true,
    disableClearable: true,
    placeholder: "Homme, Femme",
    options: SEXES,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? SEXES.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.sex || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "departmentBirth",
    label: "Département de naissance",
    type: "select",
    required: true,
    disableClearable: true,
    options: DEPARTMENTS,
    placeholder: "Bouches-du-Rhône",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? DEPARTMENTS.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.departmentBirth || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "cityBirth",
    label: "Commune de naissance",
    type: "select",
    required: true,
    placeholder: "Marseille",
    options: [],
    getInitial: (info) => info?.individual?.individualContract?.cityBirth || null,
    getOptionLabel: (opt) => opt.label || opt || "",
    getValue: (val) => val || null,
    customHandler: {
      fetchOptions: async (value, setOptions) => {
        if (value && value.length >= 3) {
          try {
            const response = await getCommunes.query({ name: value });
            const formattedData = getCommunes.format({ data: response });
            if (!formattedData || !formattedData.data) {
              setOptions([]);
              return;
            }
            const communes = formattedData.data.map((c) => ({
              label: c.nom,
              value: c.nom,
            }));
            setOptions(communes);
          } catch (error) {
            setOptions([]);
            console.log('Error fetching communes:', error);
          }
        } else {
          setOptions([]);
        }
      },
    },
    endAdornment: <ExpandMoreRounded />,
    validation: {
      message: "La commune de naissance est requise",
    },
  },
  {
    name: "nationality",
    label: "Nationalité",
    type: "select",
    required: true,
    disableClearable: true,
    options: NATIONALITY,
    placeholder: "Française",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? NATIONALITY.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.nationality || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "socialRegime",
    label: "Régime social",
    type: "select",
    required: true,
    disableClearable: true,
    options: SOCIAL_REGIME,
    placeholder: "URSSAF",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? SOCIAL_REGIME.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.socialRegime || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "sportRegistered",
    label: "Déclare être inscrit sur la liste des sportifs de haut niveau",
    type: "select",
    required: true,
    disableClearable: true,
    options: YESNO,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.individual?.individualContract?.sportRegistered.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "entrepreneur",
    label: "Déclare avoir un projet de création ou de reprise d'entreprise",
    type: "select",
    required: true,
    disableClearable: true,
    options: YESNO,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.individual?.individualContract?.entrepreneur.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "disabled",
    label: "Travailleur Handicapé",
    type: "select",
    required: true,
    disableClearable: true,
    options: YESNO,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.individual?.individualContract?.disabled?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "address",
    label: "Adresse",
    type: "addressNested",
    required: true,
    placeholder: "61 Bd des Dames, 13002 Marseille",
    getInitial: (info) => info?.individual?.address || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "addressDetails",
    label: "Complément d'adresse",
    type: "text",
    required: false,
    placeholder: "Étage, porte...",
    getInitial: (info) => info?.individual?.individualContract?.addressDetails || null,
  },
  {
    name: "number",
    label: "N° de rue",
    type: "text",
    required: true,
    placeholder: "61",
    getInitial: (info) => info?.individual?.individualContract?.number || null,
  },
  {
    name: "street",
    label: "Voie",
    type: "text",
    required: true,
    placeholder: "Bd des Dames",
    getInitial: (info) => info?.individual?.individualContract?.street || null,
  },
  {
    name: "situationBeforeContract",
    label: "Situation avant contrat",
    type: "select",
    required: true,
    options: SITUATION_BEFORE_CONTRACT,
    disableClearable: true,
    placeholder: "Salarié",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? SITUATION_BEFORE_CONTRACT.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.situationBeforeContract || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "lastDiploma",
    label: "Dernier diplôme ou titre préparé",
    type: "select",
    required: true,
    options: LAST_DISPLOMA,
    disableClearable: true,
    placeholder: "CAP",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? LAST_DISPLOMA.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.lastDiploma || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "lastDiplomaYear",
    label: "Dernière classe / année suivie",
    type: "select",
    required: true,
    options: LAST_DIPLOMA_YEAR,
    disableClearable: true,
    placeholder: "L'apprenti a interrompu ses études en classe de 3è",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? LAST_DIPLOMA_YEAR.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.lastDiplomaYear || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "diplomaLabel",
    label: "Intitulé précis du dernier diplôme ou titre préparé",
    type: "text",
    required: true,
    placeholder: "BTS Informatique",
    getInitial: (info) => info?.individual?.individualContract?.diplomaLabel || null,
  },
  {
    name: "bestDiploma",
    label: "Diplôme ou titre le plus élevé obtenu",
    type: "select",
    required: true,
    options: LAST_DISPLOMA,
    disableClearable: true,
    placeholder: "CAP",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? LAST_DISPLOMA.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.individual?.individualContract?.bestDiploma || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "legalFirstname",
    label: "Prénom du représentant légal",
    type: "text",
    required: false,
    placeholder: "Jean",
    getInitial: (info) => info?.individual?.individualContract?.legalFirstname || null,
  },
  {
    name: "legalLastname",
    label: "Nom du représentant légal",
    type: "text",
    required: false,
    placeholder: "Dupont",
    getInitial: (info) => info?.individual?.individualContract?.legalLastname || null,
  },
  {
    name: "legalEmail",
    label: "Email du représentant légal",
    type: "text",
    required: false,
    placeholder: "jean.dupont@example.com",
    getInitial: (info) => info?.individual?.individualContract?.legalEmail || null,
  },
  {
    name: "legalPhone",
    label: "Téléphone du représentant légal",
    type: "phone",
    required: false,
    placeholder: "+33 6 12 34 56 78",
    getInitial: (info) => info?.individual?.individualContract?.legalPhone || null,
  },
  {
    name: "legalAddress",
    label: "Adresse du représentant légal",
    type: "address",
    required: false,
    placeholder: "61 Bd des Dames, 13002 Marseille",
    getInitial: (info) => info?.individual?.individualContract?.legalAddress || null,
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "legalPostalCode",
    label: "Code postal du représentant légal",
    type: "none",
    required: false,
    getInitial: (info) => info?.individual?.individualContract?.legalPostalCode || null,
  },
  {
    name: "legalCity",
    label: "Ville du représentant légal",
    type: "none",
    required: false,
    getInitial: (info) => info?.individual?.individualContract?.legalCity || null,
  },
  {
    name: "legalAddressDetails",
    label: "Complément d'adresse du représentant légal",
    type: "text",
    required: false,
    placeholder: "Étage, porte...",
    getInitial: (info) => info?.individual?.individualContract?.legalAddressDetails || null,
  },
  {
    name: "legalNumber",
    label: "N° de rue du représentant légal",
    type: "text",
    required: false,
    placeholder: "61",
    getInitial: (info) => info?.individual?.individualContract?.legalNumber || null,
  },
  {
    name: "legalStreet",
    label: "Voie du représentant légal",
    type: "text",
    required: false,
    placeholder: "Bd des Dames",
    getInitial: (info) => info?.individual?.individualContract?.legalStreet || null,
  },
  {
    name: "phone",
    label: "Téléphone",
    type: "none",
    required: false,
    getInitial: (info) => info?.individual?.phone || null,
  }
];

export const masterFormConfig = [
  {
    name: "businessContractMasters[0].lastname",
    label: "Nom du maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "Dupont",
    getInitial: (info) => info?.businessContractMasters?.[0]?.lastname || null,
    validation: {
      message: "Le nom est requis.",
    },
    value: (info) => info?.businessContractMasters?.[0]?.lastname || null,
  },
  {
    name: "businessContractMasters[0].firstname",
    label: "Prénom du maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "Jean",
    getInitial: (info) => info?.businessContractMasters?.[0]?.firstname || null,
    validation: {
      message: "Le prénom est requis.",
    },
    value: (info) => info?.businessContractMasters?.[0]?.firstname || null,
  },
  {
    name: "businessContractMasters[0].email",
    label: "Email du maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "jean.dupont@example.com",
    getInitial: (info) => info?.businessContractMasters?.[0]?.email || null,
    validation: {
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "L'email doit être valide.",
    },
    value: (info) => info?.businessContractMasters?.[0]?.email || null,
  },
  {
    name: "businessContractMasters[0].birthDate",
    label: "Date de naissance du maître d'apprentissage",
    type: "date",
    required: false,
    placeholder: "JJ/MM/AAAA",
    getInitial: (info) => info?.businessContractMasters?.[0]?.birthDate || null,
    validation: {
      message: "La date de naissance est requise.",
    },
    value: (info) => info?.businessContractMasters?.[0]?.birthDate || null,
  },
  {
    name: "businessContractMasters[0].occupiedPosition",
    label: "Emploi occupé du maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "Formateur",
    getInitial: (info) => info?.businessContractMasters?.[0]?.occupiedPosition || null,
    validation: {
      message: "L'emploi occupé est requis.",
    },
    value: (info) => info?.businessContractMasters?.[0]?.occupiedPosition || null,
  },
  {
    name: "businessContractMasters[0].diplomaLabel",
    label: "Diplôme ou titre le plus élevé obtenu",
    type: "text",
    required: false,
    placeholder: "Master en Education",
    getInitial: (info) => info?.businessContractMasters?.[0]?.diplomaLabel || null,
    validation: {
      message: "Le diplôme est requis.",
    },
    value: (info) => info?.businessContractMasters?.[0]?.diplomaLabel || null,
  },
  {
    name: "businessContractMasters[0].bestDiploma",
    label: "Niveau de diplôme ou titre le plus élevé obtenu",
    type: "select",
    required: false,
    options: BEST_DIPLOMA,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? BEST_DIPLOMA.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.businessContractMasters?.[0]?.bestDiploma || null,
    endAdornment: <ExpandMoreRounded />,
    validation: {
      message: "Le niveau de diplôme est requis.",
    },
    value: (info) => BEST_DIPLOMA.find((o) => o.value === info?.businessContractMasters?.[0]?.bestDiploma) || null,
  },
  // Second Master (optional, shown dynamically)
  {
    name: "businessContractMasters[1].lastname",
    label: "Nom du second maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "Martin",
    getInitial: (info) => info?.businessContractMasters?.[1]?.lastname || null,
    value: (info) => info?.businessContractMasters?.[1]?.lastname || null,
  },
  {
    name: "businessContractMasters[1].firstname",
    label: "Prénom du second maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "Marie",
    getInitial: (info) => info?.businessContractMasters?.[1]?.firstname || null,
    value: (info) => info?.businessContractMasters?.[1]?.firstname || null,
  },
  {
    name: "businessContractMasters[1].email",
    label: "Email du second maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "marie.martin@example.com",
    getInitial: (info) => info?.businessContractMasters?.[1]?.email || null,
    value: (info) => info?.businessContractMasters?.[1]?.email || null,
  },
  {
    name: "businessContractMasters[1].birthDate",
    label: "Date de naissance du second maître d'apprentissage",
    type: "date",
    required: false,
    placeholder: "JJ/MM/AAAA",
    getInitial: (info) => info?.businessContractMasters?.[1]?.birthDate || null,
    value: (info) => info?.businessContractMasters?.[1]?.birthDate || null,
  },
  {
    name: "businessContractMasters[1].occupiedPosition",
    label: "Emploi occupé du second maître d'apprentissage",
    type: "text",
    required: false,
    placeholder: "Superviseur",
    getInitial: (info) => info?.businessContractMasters?.[1]?.occupiedPosition || null,
    value: (info) => info?.businessContractMasters?.[1]?.occupiedPosition || null,
  },
  {
    name: "businessContractMasters[1].diplomaLabel",
    label: "Diplôme ou titre le plus élevé obtenu (second maître)",
    type: "text",
    required: false,
    placeholder: "Licence en Gestion",
    getInitial: (info) => info?.businessContractMasters?.[1]?.diplomaLabel || null,
    value: (info) => info?.businessContractMasters?.[1]?.diplomaLabel || null,
  },
  {
    name: "businessContractMasters[1].bestDiploma",
    label: "Niveau de diplôme ou titre le plus élevé obtenu (second maître)",
    type: "select",
    required: false,
    options: BEST_DIPLOMA,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? BEST_DIPLOMA.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.businessContractMasters?.[1]?.bestDiploma || null,
    endAdornment: <ExpandMoreRounded />,
    value: (info) => BEST_DIPLOMA.find((o) => o.value === info?.businessContractMasters?.[1]?.bestDiploma) || null,
  },
];

export const contractFormConfig = [
  {
    name: "contractualMode",
    label: "Mode contractuel de l'apprentissage",
    type: "select",
    required: true,
    options: CONTRACTUAL_MODE,
    disableClearable: true,
    placeholder: "Entreprise de travail temporaire",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? CONTRACTUAL_MODE.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.contractualMode || null,
    endAdornment: <ExpandMoreRounded />,
    validation: {
      message: "Le mode contractuel est requis.",
    },
    value: (info) => CONTRACTUAL_MODE.find((o) => o.value === info?.contractualMode) || null,
  },
  {
    name: "contractType",
    label: "Type de contrat ou d'avenant",
    type: "select",
    required: true,
    options: OPCO_CONTRACT_TYPE,
    disableClearable: true,
    placeholder: "Modification du diplôme préparé par l'apprenti",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? OPCO_CONTRACT_TYPE.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.contractType || null,
    endAdornment: <ExpandMoreRounded />,
    validation: {
      message: "Le type de contrat est requis.",
    },
    value: (info) => OPCO_CONTRACT_TYPE.find((o) => o.value === info?.contractType) || null,
  },
  {
    name: "derogationType",
    label: "Type de dérogation",
    type: "select",
    required: false,
    options: DEROGATION_TYPE,
    placeholder: "Cumul de dérogations",
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? DEROGATION_TYPE.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.derogationType || null,
    endAdornment: <ExpandMoreRounded />,
    value: (info) => DEROGATION_TYPE.find((o) => o.value === info?.derogationType) || null,
  },
  {
    name: "previousContract",
    label: "Numéro du contrat ou avenant précédent",
    type: "text",
    required: false,
    placeholder: "12345",
    getInitial: (info) => info?.previousContract || null,
  },
  {
    name: "executionDate",
    label: "Date de début d'exécution du contrat",
    type: "date",
    required: true,
    placeholder: "JJ/MM/AAAA",
    getInitial: (info) => info?.executionDate || null,
    validation: {
      message: "La date de début d'exécution est requise.",
    },
  },
  {
    name: "effectiveDate",
    label: "Date de début de formation pratique chez l'employeur",
    type: "date",
    required: true,
    placeholder: "JJ/MM/AAAA",
    getInitial: (info) => info?.effectiveDate || null,
    validation: {
      message: "La date de début de formation est requise.",
    },
  },
  {
    name: "endDate",
    label: "Date de fin du contrat ou apprentissage",
    type: "date",
    required: true,
    placeholder: "JJ/MM/AAAA",
    getInitial: (info) => info?.endDate || null,
    validation: {
      message: "La date de fin est requise.",
    },
  },
  {
    name: "amendmentDate",
    label: "Si avenant, date d'effet",
    type: "date",
    required: false,
    placeholder: "JJ/MM/AAAA",
    getInitial: (info) => info?.amendmentDate || null,
  },
  {
    name: "hebdoHours",
    label: "Temps de travail hebdomadaire (heures)",
    type: "number",
    required: true,
    placeholder: "35",
    getInitial: (info) => info?.hebdoHours || null,
    validation: {
      min: 0,
      max: 70,
      message: "Les heures doivent être entre 0 et 70.",
    },
  },
  {
    name: "hebdoMinutes",
    label: "Temps de travail hebdomadaire (minutes)",
    type: "number",
    required: false,
    placeholder: "0",
    getInitial: (info) => info?.hebdoMinutes || 0,
    validation: {
      min: 0,
      max: 59,
      message: "Les minutes doivent être entre 0 et 59.",
    },
  },
  {
    name: "dangerousWork",
    label: "Travail exposé à des risques particuliers (Machines dangereuses, produits toxiques, etc.)",
    type: "select",
    required: true,
    options: YESNO,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.dangerousWork?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "grossSalary",
    label: "Salaire à l'embauche (brut)",
    type: "number",
    required: true,
    placeholder: "3500",
    getInitial: (info) => info?.grossSalary || "",
  },
  {
    name: "advantageFood",
    label: "Avantage en nature nourriture",
    type: "number",
    required: false,
    placeholder: "0",
    getInitial: (info) => info?.advantageFood || "",
  },
  {
    name: "advantageAccommodation",
    label: "Avantage en nature logement",
    type: "number",
    required: false,
    placeholder: "0",
    getInitial: (info) => info?.advantageAccommodation || "",
  },
  {
    name: "otherAdvantages",
    label: "Autre avantages",
    type: "select",
    required: true,
    options: YESNO,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.otherAdvantages?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "montantRQTH1",
    label: "Montant RQTH année 1",
    type: "number",
    required: false,
    placeholder: "0",
    getInitial: (info) => info?.montantRQTH1 || "",
  },
  {
    name: "montantRQTH2",
    label: "Montant RQTH année 2",
    type: "number",
    required: false,
    placeholder: "0",
    getInitial: (info) => info?.montantRQTH2 || "",
  },
  {
    name: "montantRQTH3",
    label: "Montant RQTH année 3",
    type: "number",
    required: false,
    placeholder: "0",
    getInitial: (info) => info?.montantRQTH3 || "",
  },
  {
    name: "montantRQTH4",
    label: "Montant RQTH année 4",
    type: "number",
    required: false,
    placeholder: "0",
    getInitial: (info) => info?.montantRQTH4 || "",
  },
  {
    type: "custom",
    render: (object) => <DynamicContractLengths formik={object?.formik} settings={object?.settings} />,
    getInitial: (info) => info?.businessContractLengths || [],
  },
];

export const trainingFormConfig = [
  {
    name: "label",
    label: "Titre visé par l'apprenti",
    type: "text",
    disabled: true,
    placeholder: "BTS Informatique",
    getInitial: (info) => info?.degree?.label || "",
  },
  {
    name: "diplomaType",
    label: "Type de diplôme",
    type: "select",
    disabled: true,
    options: LAST_DISPLOMA,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => (val ? LAST_DISPLOMA.find((o) => o.value === val) : null) || null,
    getInitial: (info) => info?.diplomaType || null,
    value: (info) => LAST_DISPLOMA.find((o) => o.value === info?.diplomaType) || null,
  },
  {
    name: "diplomaLabel",
    label: "Intitulé précis du titre préparé",
    type: "text",
    disabled: true,
    placeholder: "Master of Science IT & Business",
    getInitial: (info) => info?.diplomaLabel || "",
  },
  {
    name: "diplomaCode",
    label: "Code du diplôme",
    type: "text",
    disabled: true,
    placeholder: "123456",
    getInitial: (info) => info?.diplomaCode || "",
  },
  {
    name: "rncp",
    label: "Code RNCP",
    type: "text",
    disabled: true,
    placeholder: "13305",
    getInitial: (info) => info?.rncp || "",
  },
  {
    name: "trainingDuration",
    label: "Durée de la formation",
    type: "number",
    disabled: true,
    placeholder: "12",
    getInitial: (info) => info?.trainingDuration || "",
  },
  {
    name: "trainingRemoteDuration",
    label: "Durée de la formation à distance",
    type: "number",
    disabled: true,
    placeholder: "0",
    getInitial: (info) => info?.trainingRemoteDuration || "",
  },
  {
    name: "trainingTotalCost",
    label: "Coût total pédagogique CFA (par an)",
    type: "number",
    required: true,
    placeholder: "15000",
    getInitial: (info) => info?.trainingTotalCost || "",
    validation: {
      message: "Le coût total est requis.",
    },
  },
  {
    name: "opcoSupport",
    label: "Prise en charge OPCO (par an)",
    type: "number",
    required: false,
    placeholder: "10000",
    getInitial: (info) => info?.opcoSupport || "",
  },
  {
    name: "businessCharge",
    label: "Reste à charge entreprise (par an)",
    type: "number",
    required: false,
    placeholder: "5000",
    getInitial: (info) => info?.businessCharge || "",
  },
  {
    name: "foodNumber",
    label: "Nombre de repas",
    type: "number",
    required: false,
    placeholder: "10",
    getInitial: (info) => info?.foodNumber || "",
  },
  {
    name: "foodCost",
    label: "Coût par repas",
    type: "number",
    required: false,
    placeholder: "5",
    getInitial: (info) => info?.foodCost || "",
  },
  {
    name: "accomodationNumber",
    label: "Nombre de nuitées",
    type: "number",
    required: false,
    placeholder: "20",
    getInitial: (info) => info?.accomodationNumber || "",
  },
  {
    name: "accomodationCost",
    label: "Coût par nuitée",
    type: "number",
    required: false,
    placeholder: "50",
    getInitial: (info) => info?.accomodationCost || "",
  },
  {
    name: "requiredMaterialCost",
    label: "Coût du matériel obligatoire",
    type: "number",
    required: false,
    placeholder: "200",
    getInitial: (info) => info?.requiredMaterialCost || "",
  },
  {
    name: "internationalMobility",
    label: "Mobilité internationale",
    type: "select",
    required: true,
    options: YESNO,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.internationalMobility?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "drom",
    label: "Accompagnement DROM",
    type: "select",
    required: true,
    options: YESNO,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.drom?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
  {
    name: "cfaLocation",
    label: "Localisation CFA",
    type: "select",
    required: true,
    options: YESNO,
    disableClearable: true,
    getOptionLabel: (opt) => opt.label || "",
    getValue: (val) => YESNO.find((o) => o.value === val) || "false",
    getInitial: (info) => info?.cfaLocation?.toString() || "false",
    endAdornment: <ExpandMoreRounded />,
  },
];